export default __webpack_public_path__ + "static/media/USK_6.7459eeb0.png";